import { pg_tileserv_url } from "../../../utils";

const Manzaneos = {
    enable: true,
    checked: false,
    initialDisplay: true,
    excludeCities: [],
    source: "pg_tileserv",
    url: pg_tileserv_url + "REPLACECITYNAME.manzaneos",
    zindex: 3,
    type: "single",
    popup: {
        default: {
            content: {
                es: {},
            },
            separators: {
                decimal: [],
                thousand: [],
            },
        },
    },
    titleSideBar: "Mobility Indicators Content.layers.Manzaneos",
    style: {
        regular: false,
        fillColor: "rgb(212, 218, 220)",
        strokeColor: "rgb(35, 35, 35)",
        strokeWidth: 0.7,
        strokeLineDash: [],
        points: 0,
        radius: 0,
        angle: 0,
        rotation: 0,
    },
    legend: {
        default: {
            title: "Mobility Indicators Content.layersLegend.Manzaneos.title",
            subtitle: "",
            attribute: "",
            symbol: "rectangle",
            legendCustomCssClass: "map-legend-symbol-border-1px-gray-35-35-35",
            class: [
                {
                    fillColor: "rgb(212, 218, 220)",
                    strokeColor: "rgb(35, 35, 35)",
                    strokeWidth: 0,
                    label: "Mobility Indicators Content.layersLegend.Manzaneos.classes.1",
                },
            ],
        },
    },
};

export default Manzaneos;
